import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/App.css";
import App from "@/App";

// Import brand fonts (Archivo Black + Barlow Condensed) via Google Fonts
const link = document.createElement("link");
link.rel = "stylesheet";
link.href = "https://fonts.googleapis.com/css2?family=Archivo+Black&family=Barlow+Condensed:wght@400;500;600;700&family=Rajdhani:wght@500;600;700&display=swap";
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
